import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { IdDocImageSide, SupportedIdDocType } from '@/idv2/features/collect-document/types';
type UseDocNameProps = {
  docType?: `${SupportedIdDocType}`;
  imageType?: `${IdDocImageSide}`;
};
const useDocName = t0 => {
  const $ = _c(11);
  const {
    docType,
    imageType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.id-doc.global"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== docType || $[2] !== t) {
    t2 = () => {
      switch (docType) {
        case "id_card":
          {
            return t(_temp);
          }
        case "drivers_license":
          {
            return t(_temp2);
          }
        case "passport":
          {
            return t(_temp3);
          }
        case "visa":
          {
            return t(_temp4);
          }
        case "permit":
          {
            return t(_temp5);
          }
        case "residence_document":
          {
            return t(_temp6);
          }
        case "voter_identification":
          {
            return t(_temp7);
          }
        case "passport_card":
          {
            return t(_temp8);
          }
        default:
          {
            return "";
          }
      }
    };
    $[1] = docType;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getDocName = t2;
  let t3;
  if ($[4] !== docType || $[5] !== imageType || $[6] !== t) {
    t3 = () => {
      if (imageType === "selfie") {
        return t(_temp9);
      }
      if (docType === "passport" || docType === "visa") {
        return t(_temp10);
      }
      switch (imageType) {
        case "front":
          {
            return t(_temp11);
          }
        case "back":
          {
            return t(_temp12);
          }
        default:
          {
            return "";
          }
      }
    };
    $[4] = docType;
    $[5] = imageType;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getSideName = t3;
  let t4;
  if ($[8] !== getDocName || $[9] !== getSideName) {
    t4 = {
      getDocName,
      getSideName
    };
    $[8] = getDocName;
    $[9] = getSideName;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default useDocName;
function _temp($_6) {
  return $_6["doc-name"].idCard;
}
function _temp2($_5) {
  return $_5["doc-name"].driversLicense;
}
function _temp3($_4) {
  return $_4["doc-name"].passport;
}
function _temp4($_3) {
  return $_3["doc-name"].visa;
}
function _temp5($_2) {
  return $_2["doc-name"].workPermit;
}
function _temp6($_1) {
  return $_1["doc-name"].residenceDocument;
}
function _temp7($_0) {
  return $_0["doc-name"].voterIdentification;
}
function _temp8($) {
  return $["doc-name"].passportCard;
}
function _temp9($_7) {
  return $_7.side.selfie;
}
function _temp10($_8) {
  return $_8.side.photo;
}
function _temp11($_10) {
  return $_10.side.front;
}
function _temp12($_9) {
  return $_9.side.back;
}